<template>
    <div id="dialog">
        <!-- :key="state.uuid" REMOVED THIS LINE, BECAUSE IT RUINED FOR THE ANIMATION-->
        <BaseModal :show="show" :center="true">
            <template v-if="state.windowMode">
                <component
                    :key="state.uuid"
                    v-if="optionalComponent()"
                    v-bind="props()"
                    v-on="{
                        ...listeners(),
                    }"
                    :is="optionalComponent()"
                />
                <h1 v-else>Missing component</h1>
                <!-- Should never be displayed, is only for dev usage -->
            </template>
            <div
                v-else
                :key="state.uuid"
                class="paper"
                v-on-clickaway="clickawayOff() ? () => {} : close"
            >
                <div
                    class="d-flex align-items-center mb-2"
                    :class="[
                        schoolBranding ? 'branding' : '',
                        { 'error-bg': isError() },
                    ]"
                >
                    <BaseIcon
                        v-if="isError()"
                        name="exclamation-triangle"
                        size="lg"
                        class="white mr-3"
                    />
                    <transition name="opacity" mode="out-in">
                        <h3 :key="title()" class="headline mb-0 contrast-color">
                            {{ title() }}
                        </h3>
                    </transition>
                    <div class="flex-grow"></div>
                    <IconBtn
                        style="color: white;"
                        @click="close"
                        name="times"
                        size="lg"
                    />
                </div>
                <div v-if="content()">
                    <h6 class="subtitle">{{ content() }}</h6>
                </div>
                <component
                    v-if="optionalComponent()"
                    v-bind="props()"
                    v-on="{
                        ...listeners(),
                    }"
                    :is="optionalComponent()"
                ></component>
                <div
                    v-if="actions().length > 0"
                    class="d-flex flex-row-reverse align-items-center mt-4"
                >
                    <BaseButton
                        class="ml-1"
                        v-for="a in actions()"
                        :key="a.title"
                        @click="() => callAction(a.action)"
                        :variant="a.variant"
                    >
                        {{ a.title }}
                    </BaseButton>
                </div>
            </div>
        </BaseModal>
    </div>
</template>

<script>
// Utils
import { mixin as clickaway } from 'vue-clickaway';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import { windowScroll } from '~/utils/windowUtils';
import DialogService from '~/services/DialogService';

export default {
    name: 'Dialog',
    mixins: [clickaway],
    data() {
        return {
            targetElement: null,
        };
    },
    computed: {
        state() {
            return this.$interfaces.dialogModal.getState();
        },
        show() {
            return this.state.open;
        },
    },
    methods: {
        title() {
            return this.state.title;
        },
        content() {
            return this.state.content;
        },
        actions() {
            return this.state.actions;
        },
        props() {
            return this.state.props || {};
        },
        listeners() {
            return this.state.listeners || {};
        },
        clickawayOff() {
            // console.log(this.state);
            return this.state.clickawayOff === true;
        },
        callAction(action) {
            action(this.state.resolver);
        },
        close() {
            this.state.onClose(this.state.resolver);
        },
        onKey(event) {
            if (event.key === 'Escape') {
                this.close();
            }
        },
        optionalComponent() {
            return this.state.component;
        },
        isError() {
            return this.state.isError;
        },
        schoolBranding() {
            return this.state.schoolBranding;
        },

        handleBackPress(event) {
            // TODO: Currently, this does not work as expected, fix it!!
            if (event) {
                if (event.state == 'backPressedDialog') {
                    this.handleBackPress();
                }
            } else {
                DialogService.popState();
            }
        },
    },
    watch: {
        show(shouldShow, wasShowing) {
            if (shouldShow) {
                document.addEventListener('keyup', this.onKey);
                disableBodyScroll(this.targetElement);

                // if (!wasShowing) {
                //     window.history.pushState('backPressedDialog', null, null);
                //     window.history.pushState('dummy', null, null);
                //     window.addEventListener('popstate', this.handleBackPress);
                // }
            } else {
                document.removeEventListener('keyup', this.onKey);
                enableBodyScroll(this.targetElement);

                if (wasShowing) {
                    window.removeEventListener(
                        'popstate',
                        this.handleBackPress
                    );
                }
            }
        },
    },

    mounted() {
        this.targetElement = document.getElementById('dialog');
    },
};
</script>

<style scoped>
.paper {
    display: block;
    margin: 0 auto;

    width: 100%;
    max-width: 520px;

    border-radius: var(--border-radius);
    background-color: white;
}
.paper > * {
    padding: 1rem;
}

.error-bg {
    background-color: var(--error-bg) !important;
}

.branding {
    border-radius: var(--border-radius) var(--border-radius) 0 0;
    background-color: var(--primary);
}

@media only screen and (max-width: 600px) {
    .paper {
        margin: 0 4px;
    }
}
</style>
